








































import Vue from "vue";
import RequiredLabel from "./../interface/RequiredLabel.vue";
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import * as DateUtils from "../utils/DateUtils";

export default Vue.extend({
  name: "date-input",
  components: { RequiredLabel },
  props: {
    id: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    value: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dpConfig: {
        allowInput: true,
        dateFormat: "d.m.Y",
        locale: Dutch,
        disableMobile: true,
      },
    };
  },
  methods: {
    updateValue(value): void {
      this.$emit("input", value);
    },
    isValidDateInput(date): boolean {
      if (date == null || (date == "" && !this.isRequired)) {
        return true;
      } else {
        return DateUtils.isValidDate(date);
      }
    },
  },
  computed: {
    isRequired(): boolean {
      return this.required;
    },
  },
});
